import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getCustomersListService = (params = {}) => {
  return api.get(url.GET_ALL_CUSTOMERS, params);
};

export const addCustomerService = (data) => {
  return api.create(url.ADD_CUSTOMER, data);
};

export const deleteCustomerService = (id) => {
  return api.delete(url.DELETE_CUSTOMER(id));
};

export const editCustomerService = (id, queryParams) => {
  return api.put(url.EDIT_CUSTOMER(id), queryParams);
};

// export const getCategoryByIdService=(id)=>{
//   return api.get(url.GET_MEAL_CATEGORY(id));
// }
